/**
 * Bezeichnung eines Flurstücks, wie sie in der Flächensicherung steht:
 * Gemarkung - Flur - Flurstück, fehlende Teile als „-“
 */
export const formatParcelLabel = (parcel: {
  gemarkung_name?: string;
  flur?: string;
  label?: string;
}): string =>
  [parcel.gemarkung_name || "-", parcel.flur || "-", parcel.label || "-"].join(
    " - ",
  );
